import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

function GuestGuard({ children }) {
  const account = useSelector(state => state.account);

  if (account.user) {
    return <Redirect to="/app" />;
  }

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.any
};

export default GuestGuard;
